module.exports = __webpack_public_path__ + "static/img/andarbahar_en.119c9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/andarbahar_en.png
// module id = tXBZ
// module chunks = 1